import { APP_BRAND_COLOR } from '../config';

function setTheme() {
  document.documentElement.style.setProperty('--color-brand', APP_BRAND_COLOR);
}

export { setTheme };
